<script>
  import AuthModal from "./AuthModal.svelte";
  import store from "../etleneumAccountStore";
  import Button from "./Button.svelte";

  let showModal = false;

  const close = () => (showModal = false);
</script>

<div class="hero-image">
  <div class="hero-text">
    <h1>MegaSats</h1>
    <p>Lotaria em Bitcoin</p>
    <Button clickAction={() => (showModal = true)}>
      {#if $store.id}
        Conta
      {:else}
        Login (LNURL auth)
      {/if}</Button
    >
  </div>
</div>
{#if showModal}
  <AuthModal on:close={() => (showModal = false)} />
{/if}

<style>
  .hero-image {
    background: var(--pinker);
    background: -webkit-linear-gradient(to right, var(--blue), var(--pinker));
    background: linear-gradient(to right, var(--blue), var(--pinker));
    min-height: 45%;
    width: 100%;
    /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("photographer.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; */
    position: relative;
  }

  /* Place text in the middle of the image */
  .hero-text {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }
</style>
